"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
exports.MarkdownList = styled_components_1.default.ul `
  grid-column: first / span 12;
  margin: 0 0 16px 0;
  padding-left: 36px;
  white-space: nowrap;

  > * {
    white-space: normal;
  }
`;
//# sourceMappingURL=markdown-list.js.map